module.exports = __webpack_public_path__ + "static/img/Floor_GreyOak.dedd05a.jpg";